import React, { useState, useEffect } from "react"
import { getMedicalRecordDetectListOneDay } from "../../../../api/get_medical_record_detect_list_oneday"
import { DetectListOneDay } from "../../index"

import Card from "@mui/material/Card"
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableContainer from "@mui/material/TableContainer"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"

interface ManageFacilityCreateProps {
  medical_record_id?: string | null
  onClose: () => void // モーダルを閉じるためのコールバック
}

const DetectListOneDayModal: React.FC<ManageFacilityCreateProps> = ({ medical_record_id, onClose }) => {
  const [detectListOneDay, setDetectListOneDay] = useState<DetectListOneDay[]>([])
  useEffect(() => {
    const id = medical_record_id ?? ""

    const fetchData = async () => {
      const currentPath = window.location.pathname
      const parts = currentPath.split("/")
      const currentIdFromUrl = parts[parts.length - 1]
      if ("MedicalRecord|" + currentIdFromUrl !== medical_record_id) {
        return
      }

      try {
        const response_detect_list_oneday = await getMedicalRecordDetectListOneDay(id.split("|")[1])
        setDetectListOneDay(response_detect_list_oneday.reports)
        setTimeout(fetchData, 60000)
      } catch (e) {
        console.log(e)
      }
    }

    // 初回実行
    fetchData()
  }, [])

  // ロケール対応の日付フォーマット関数
  const formatDateWithLocale = (timestamp: number, locale: string = "ja-JP"): string => {
    const date = new Date(timestamp * 1000)
    return new Intl.DateTimeFormat(locale, {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false // 24時間形式
    }).format(date)
  }

  return (
    <div className="modal-bg-cover">
      <Card
        sx={{
          width: "90%",
          maxWidth: "800px",
          maxHeight: "calc(100vh - 100px)",
          marginTop: "50px",
          marginBottom: "50px",
          paddingTop: "20px",
          paddingBottom: "20px",
          paddingLeft: "20px"
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            padding: "8px 16px",
            boxSizing: "border-box"
          }}
        >
          <MDTypography variant="h4" fontWeight="medium" style={{ flex: 1, textAlign: "left" }}>
            検知ログ
          </MDTypography>
          <button
            className="close-button"
            onClick={() => onClose()}
            style={{
              position: "absolute",
              right: 16,
              top: 8,
              background: "transparent",
              border: "none",
              fontSize: "24px",
              cursor: "pointer"
            }}
          >
            ×
          </button>
        </div>
        <MDBox style={{ height: "20px" }}></MDBox>
        <TableContainer
          sx={{
            overflowX: "auto",
            overflowY: "auto",
            height: "500px",
            marginTop: "20px",
            width: "calc(100% - 20px) !important"
          }}
        >
          <Table stickyHeader>
            <TableHead sx={{ position: "sticky", display: "table-header-group", zIndex: 3 }}>
              <TableRow
                sx={{
                  "& .MuiTableCell-root": {
                    fontSize: "0.875rem",
                    color: "text.primary",
                    fontWeight: "bold",
                    backgroundColor: "#FFFFFF"
                  }
                }}
              >
                <TableCell align="left">日時</TableCell>
                <TableCell align="left">ステータス</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {detectListOneDay.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{
                    "& .MuiTableCell-root": {
                      fontSize: "0.875rem",
                      color: "text.primary",
                      fontWeight: "normal",
                      zIndex: 0
                    }
                  }}
                >
                  <TableCell align="left">
                    <div
                      style={{
                        minWidth: "200px",
                        width: "10vw",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis"
                      }}
                      title={row.id || undefined}
                    >
                      {formatDateWithLocale(row.create_date)}
                    </div>
                  </TableCell>
                  <TableCell align="left">
                    <div style={{ minWidth: "200px" }}>{row.status}</div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </div>
  )
}

export default DetectListOneDayModal
